import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=52755410&scoped=true&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Event.vue?vue&type=style&index=1&id=52755410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52755410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52755410')) {
      api.createRecord('52755410', component.options)
    } else {
      api.reload('52755410', component.options)
    }
    module.hot.accept("./Event.vue?vue&type=template&id=52755410&scoped=true&", function () {
      api.rerender('52755410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Home/Event.vue"
export default component.exports